module.exports = __webpack_public_path__ + "static/AM_web_750x600-9a259f356f71880b61ebb56f85cc6b73.png";